import React from 'react'

const Output = (props) => {
    return (
        <div className="main__output" >
            <div className="main__output__wrapper">
                <div className="main__output__text">
                    {props.content}
                </div>
            </div>
        </div>
    )
}

export default Output


// WEBPACK FOOTER //
// ./src/components/output.js